module.exports = __webpack_public_path__ + "static/media/rss25withvovaandfriends.1bf1b82f.jpeg";